export const downloadLink = (content: string, fileName: string) => {
  const link = document.createElement('a')
  link.download = fileName
  link.href = content
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
